import { render, staticRenderFns } from "./CommonTreeviewConfigForm.vue?vue&type=template&id=21a00de6&"
import script from "./CommonTreeviewConfigForm.vue?vue&type=script&lang=js&"
export * from "./CommonTreeviewConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports